/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, put } from 'redux-saga/effects';
import {
  passkeySignInFailure,
  passkeySignInSuccess,
  signInSuccess,
} from '../reducer/userSlice';
import { passkeySignIn } from '../api';
import { isWeb } from '../storage';

export function* passkeySignInSaga(
  action: any
): Generator<any, void, unknown> {
  const { apiName, data } = action.payload;
  try {
    const response: any = yield call(passkeySignIn, apiName, data);

    // v1 shape: { status: '200', authenticateResponse: { userName, accountId, ... } }
    // v2 shape: { authenticated: true, errorFound: false, userName, accountId, ... } (flat)
    const authData =
      response?.authenticateResponse ??
      (response?.authenticated != null && !response?.errorFound
        ? response
        : null);

    const isSuccessStatus =
      response?.status === '200' ||
      response?.status === 200 ||
      (authData?.authenticated === true && authData?.errorFound === false);

    if (isSuccessStatus && authData) {
      const { accountId, customerId, authenticated, userName, productName } =
        authData;

      if (
        isWeb &&
        (productName == 'Rogers Corporate' ||
          productName == 'RogersCorporate' ||
          productName?.toLowerCase()?.includes('corporate'))
      ) {
        yield put(
          passkeySignInFailure({
            statusCode: response?.status ?? '401',
            error: {
              errCode: 'COORP_401_USER_ERROR',
              msg: 'You are trying to sign into the consumer portal. Click here to sign into the corporate user login.',
              statusCode: 401,
            },
          })
        );
      } else {
        const sessionPayload = {
          accountId,
          customerId,
          authenticated,
          data,
          userName,
          productName,
        };
        yield put(passkeySignInSuccess(sessionPayload));
        yield put(signInSuccess(sessionPayload));
      }
    } else {
      // v1 error fields: { status, detail, errorCode }
      // v2 error fields: { errorFound: true, message }
      const status = response?.status ?? null;
      const detail = response?.detail ?? response?.message ?? 'An unknown error occurred.';
      const errorCode = response?.errorCode ?? null;

      if (status != null && status === '412') {
        yield put(
          passkeySignInFailure({
            statusCode: status,
            error: {
              errCode: 'UNKNOWN_ERROR',
              msg: 'An unknown error occurred.',
              statusCode: status,
            },
          })
        );
      } else if (status != null) {
        yield put(
          passkeySignInFailure({
            statusCode: status,
            error: {
              errCode: errorCode ? errorCode : 'UNKNOWN_ERROR',
              msg: detail,
              statusCode: status,
            },
          })
        );
      } else {
        yield put(
          passkeySignInFailure({
            statusCode: '500',
            error: {
              errCode: 'ERR_503_SVC_NOT_AVAIL',
              msg: detail,
              statusCode: '500',
            },
          })
        );
      }
    }
  } catch (error: any) {
    const {
      status = '500',
      errorCode = 'UNKNOWN_ERROR',
      detail = 'An unknown error occurred.',
    } = error?.data ?? error ?? {};
    yield put(
      passkeySignInFailure({
        statusCode: status,
        error: {
          errCode: errorCode,
          msg: detail,
        },
      })
    );
  }
}
